import {
  orangeShades,
  primaryColors,
  transparentColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'
import { floatingSurface } from '@/shared/styles/floatingSurface.styles'

export const alertStyles = {
  padding: '0.125rem 0.5rem 0.125rem 0.375rem',
  display: 'flex',
  boxSizing: 'border-box',
  alignItems: 'center',
  borderRadius: '0.125rem',
  gap: '0.5rem',
  marginBottom: '0.25rem',
  backgroundColor: transparentColors.blackShade3,
  '.MuiAlert-action': {
    marginRight: '0',
    padding: '0'
  },

  '.MuiAlert-icon': {
    padding: 0,
    margin: 0,
    alignSelf: 'flex-start',
    paddingTop: '0.125rem'
  },
  '&.MuiAlert-colorInfo': {
    borderLeft: `0.25rem solid ${whiteShades.shade1}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorError': {
    borderLeft: `0.25rem solid ${primaryColors.orange}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorSuccess': {
    borderLeft: `0.25rem solid ${primaryColors.white}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorWarning': {
    borderLeft: `0.25rem solid ${orangeShades.shade1}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '.MuiAlert-message': {
    padding: 0,
    textAlign: 'center',
    height: 'fit-content',
    marginRight: '0.5rem'
  }
}

/**
 * The same alert, raised off the page.
 *
 * An alert in a column of fields reads fine on its own plate: everything around
 * it is a field, so a 30% black wash is enough to set it apart. One that floats
 * over a canvas has nothing around it, and on this app's near-black editor that
 * wash is invisible, leaving a sentence apparently loose on the background.
 * This gives it the app's floating surface instead, the same one every dropdown
 * and tooltip sits on, and the severity edge from `alertStyles` survives it
 * because a class selector beats the base `border` declaration.
 */
export const raisedAlertStyles = {
  ...floatingSurface,
  borderRadius: '0.5rem',
  padding: '0.375rem 0.625rem 0.375rem 0.5rem',
  marginBottom: 0
}
